"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bannerZoneServices_service_1 = require("./Services/bannerZoneServices.service");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var service_service_1 = require("./Services/service.service");
var search_small_component_1 = require("./Adv/search-small/search-small.component");
var version_check_service_1 = require("./Services/version-check.service");
var material_1 = require("@angular/material");
var new_version_dialog_component_1 = require("./Dialogs/new-version-dialog/new-version-dialog.component");
var platform_browser_1 = require("@angular/platform-browser");
var WickedApiClient_1 = require("./api/WickedApiClient");
var seo_service_1 = require("./Services/seo.service");
var operators_1 = require("rxjs/operators");
var google_analytics_service_1 = require("./Services/google.analytics.service");
var AppComponent = /** @class */ (function () {
    function AppComponent(services, router, versionCheck, dialog, sanitizer, adClient, seo, googleAnalyticsEventsService, bannersService) {
        var _this = this;
        this.services = services;
        this.router = router;
        this.versionCheck = versionCheck;
        this.dialog = dialog;
        this.sanitizer = sanitizer;
        this.adClient = adClient;
        this.seo = seo;
        this.bannersService = bannersService;
        this.title = "WL";
        this.seoUrlsMap = [];
        this.citiesUrlMap = ["/nm-albuquerque", "/ga-atlanta", "/tx-austin", "/ca-bakersfield", "/md-baltimore", "/al-birmingham", "/ny-bronx", "/ny-brooklyn",
            "/ny-buffalo", "/nc-charlotte", "/il-chicago", "/oh-cincinnati", "/oh-cleveland", "/co-colorado-springs", "/oh-columbus", "/tx-dallas", "/oh-dayton",
            "/co-denver", "/mi-detroit", "/tx-el-paso", "/fl-fort-lauderdale", "/tx-fort-worth", "/ca-fresno", "/tx-houston", "/in-indianapolis", "/fl-jacksonville",
            "/mo-kansas-city", "/nv-las-vegas", "/ca-long-beach", "/ca-los-angeles", "/ky-louisville", "/tn-memphis", "/az-mesa", "/fl-miami", "/wi-milwaukee",
            "/mn-minneapolis", "/tn-nashville", "/ny-new-york", "/ok-oklahoma-city", "/ne-omaha", "/fl-orlando", "/pa-philadelphia", "/az-phoenix", "/pa-pittsburgh",
            "/or-portland", "/nc-raleigh", "/ny-rochester", "/ca-sacramento", "/mo-saint-louis", "/mn-saint-paul", "/ut-salt-lake-city", "/tx-san-antonio",
            "/ca-san-diego", "/ca-san-francisco", "/ca-san-jose", "/wa-seattle", "/ny-staten-island", "/fl-tampa", "/az-tucson", "/dc-washington"];
        this.categoriesUrlMap = ["women-seeking-men", "women-seeking-women", "women-seeking-couples", "women-seeking-transgenders", "men-seeking-women", "men-seeking-men", "men-seeking-couples", "men-seeking-transgenders", "couples-seeking-women", "couples-seeking-men", "couples-seeking-couples", "couples-seeking-transgenders", "transgenders-seeking-women", "transgenders-seeking-men", "transgenders-seeking-couples", "transgenders-seeking-transgenders", "missed-connections"];
        this.isSticky = false;
        // merge two urls arrays
        this.seoUrlsMap = this.citiesUrlMap.concat(this.categoriesUrlMap);
        this.router.events.pipe(operators_1.filter(function (event) { return event instanceof router_1.NavigationEnd; })).subscribe(function (event) {
            ga('set', 'page', event.urlAfterRedirects);
            ga('send', 'pageview');
            var forCurrentUrl = _this.urlIsForStaticChanges(event.url);
            _this.seo.removeCanonicalLink();
            if (forCurrentUrl.isContain) {
                if (forCurrentUrl.mainUrl != event.url) {
                    if (forCurrentUrl.mainUrl.charAt(0) == '/') {
                        //is property link
                        _this.seo.updateCanonicalLink(forCurrentUrl.mainUrl);
                    }
                }
                _this.seo.getMetaSeo(event.url.replace("/", "")).then(function (metaSeoTags) {
                    _this.seo.updateMeta(metaSeoTags.metaTitle, metaSeoTags.metaDescription);
                });
            }
            else if (event.url != "/search-results") {
                _this.seo.updateMetaDefaults();
            }
        });
    }
    AppComponent.prototype.urlIsForStaticChanges = function (currentUrl) {
        var tmpUrl = "";
        var isContain = this.seoUrlsMap.some(function (item) {
            if (currentUrl.includes(item)) {
                tmpUrl = item;
                return true;
            }
        });
        return { isContain: isContain, mainUrl: tmpUrl };
    };
    Object.defineProperty(AppComponent.prototype, "isPremium", {
        get: function () {
            return this.services.userService.isPremium();
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.getAnimationData = function (outlet) {
        return outlet && outlet.activatedRouteData && outlet.activatedRouteData["animation"];
    };
    AppComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.versionCheck.versionChanged.subscribe(function (changed) {
            if (changed) {
                var dialogRef = _this.dialog.open(new_version_dialog_component_1.NewVersionDialogComponent, {
                    autoFocus: true,
                    hasBackdrop: true,
                    disableClose: true,
                    data: {},
                });
            }
        });
        this.bannersService.getAllUserBaners();
    };
    AppComponent.prototype.ngAfterViewInit = function () {
        var premium = this.services.userService.isPremium();
    };
    Object.defineProperty(AppComponent.prototype, "currentUrl", {
        //@HostListener('window:scroll', ['$event'])
        //checkScroll() {
        //  this.isSticky = window.pageYOffset >= 100;
        //}
        get: function () {
            return this.services.route.url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "canShowSearchForm", {
        get: function () {
            return true; //this.currentUrl=='search-results';
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.onUserLogout = function () {
        this.searchSmall.clearSearch();
    };
    return AppComponent;
}());
exports.AppComponent = AppComponent;
